(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define(factory) :
  (global.Layzr = factory());
}(this, (function () { 'use strict';

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var knot = function knot() {
  var extended = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var events = Object.create(null);

  function on(name, handler) {
    events[name] = events[name] || [];
    events[name].push(handler);
    return this;
  }

  function once(name, handler) {
    handler._once = true;
    on(name, handler);
    return this;
  }

  function off(name) {
    var handler = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    handler ? events[name].splice(events[name].indexOf(handler), 1) : delete events[name];

    return this;
  }

  function emit(name) {
    var _this = this;

    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    // cache the events, to avoid consequences of mutation
    var cache = events[name] && events[name].slice();

    // only fire handlers if they exist
    cache && cache.forEach(function (handler) {
      // remove handlers added with 'once'
      handler._once && off(name, handler);

      // set 'this' context, pass args to handlers
      handler.apply(_this, args);
    });

    return this;
  }

  return _extends({}, extended, {

    on: on,
    once: once,
    off: off,
    emit: emit
  });
};

var layzr = (function () {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  // private

  var prevLoc = getLoc();
  var ticking = void 0;

  var nodes = void 0;
  var windowHeight = void 0;

  // options

  var settings = {
    normal: options.normal || 'data-normal',
    retina: options.retina || 'data-retina',
    srcset: options.srcset || 'data-srcset',
    threshold: options.threshold || 0
  };

  // feature detection
  // https://github.com/Modernizr/Modernizr/blob/master/feature-detects/img/srcset.js

  var srcset = document.body.classList.contains('srcset') || 'srcset' in document.createElement('img');

  // device pixel ratio
  // not supported in IE10 - https://msdn.microsoft.com/en-us/library/dn265030(v=vs.85).aspx

  var dpr = window.devicePixelRatio || window.screen.deviceXDPI / window.screen.logicalXDPI;

  // instance

  var instance = knot({
    handlers: handlers,
    check: check,
    update: update
  });

  return instance;

  // location helper

  function getLoc() {
    return window.scrollY || window.pageYOffset;
  }

  // debounce helpers

  function requestScroll() {
    prevLoc = getLoc();
    requestFrame();
  }

  function requestFrame() {
    if (!ticking) {
      window.requestAnimationFrame(function () {
        return check();
      });
      ticking = true;
    }
  }

  // offset helper

  function getOffset(node) {
    return node.getBoundingClientRect().top + prevLoc;
  }

  // in viewport helper

  function inViewport(node) {
    var viewTop = prevLoc;
    var viewBot = viewTop + windowHeight;

    var nodeTop = getOffset(node);
    var nodeBot = nodeTop + node.offsetHeight;

    var offset = settings.threshold / 100 * windowHeight;

    return nodeBot >= viewTop - offset && nodeTop <= viewBot + offset;
  }

  // source helper

  function setSource(node) {
    instance.emit('src:before', node);

    // prefer srcset, fallback to pixel density
    if (srcset && node.hasAttribute(settings.srcset)) {
      node.setAttribute('srcset', node.getAttribute(settings.srcset));
    } else {
      var retina = dpr > 1 && node.getAttribute(settings.retina);
      node.setAttribute('src', retina || node.getAttribute(settings.normal));
    }

    instance.emit('src:after', node);[settings.normal, settings.retina, settings.srcset].forEach(function (attr) {
      return node.removeAttribute(attr);
    });

    update();
  }

  // API

  function handlers(flag) {
    var action = flag ? 'addEventListener' : 'removeEventListener';['scroll', 'resize'].forEach(function (event) {
      return window[action](event, requestScroll);
    });
    return this;
  }

  function check() {
    windowHeight = window.innerHeight;

    nodes.forEach(function (node) {
      return inViewport(node) && setSource(node);
    });

    ticking = false;
    return this;
  }

  function update() {
    nodes = Array.prototype.slice.call(document.querySelectorAll('[' + settings.normal + ']'));
    return this;
  }
});

return layzr;

})));

},{}],2:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var General = function () {
	function General() {
		_classCallCheck(this, General);

		this.addPrefilter();
		this.addMagnificPopup();
		this.addScrollMagic();
	}

	_createClass(General, [{
		key: 'addScrollMagic',
		value: function addScrollMagic() {
			$('.js-scroll-jump').on('click', function (event) {
				var $el = $(event.currentTarget);
				var $jumpTarget = $($el.attr('href'));
				$('html, body').animate({
					scrollTop: $jumpTarget.offset().top
				}, 'slow');
				return false;
			});
		}
	}, {
		key: 'addPrefilter',
		value: function addPrefilter() {
			$(function () {
				$.ajaxSetup({
					headers: {
						'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
					}
				});
			});
		}
	}, {
		key: 'addMagnificPopup',
		value: function addMagnificPopup() {

			$('.video-link').magnificPopup({
				type: 'iframe',
				iframe: {
					markup: '<div class="mfp-iframe-scaler">' + '<div class="mfp-close"></div>' + '<iframe class="mfp-iframe" frameborder="0" allowfullscreen></iframe>' + '</div>',

					patterns: {
						vimeo: {
							index: 'vimeo.com/',
							id: '/',
							src: '//player.vimeo.com/video/%id%?autoplay=1'
						},
						youtube: {
							index: 'youtube.com/', // String that detects type of video (in this case YouTube). Simply via url.indexOf(index).

							id: 'v=', // String that splits URL in a two parts, second part should be %id%
							// Or null - full URL will be returned
							// Or a function that should return %id%, for example:
							// id: function(url) { return 'parsed id'; }

							src: '//www.youtube.com/embed/%id%?autoplay=1' // URL that will be set as a source for iframe.
						}
					},
					srcAction: 'iframe_src'
				},
				fixedContentPos: false,
				preloader: true
			});
		}
	}]);

	return General;
}();

exports.default = General;

},{}],3:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Imagebox = function () {
	function Imagebox() {
		_classCallCheck(this, Imagebox);

		this.initListeners();
	}

	_createClass(Imagebox, [{
		key: 'initListeners',
		value: function initListeners() {
			var _this = this;

			// $('.Imagebox--picture-vcenter').css({       
			//      		'margin-top' : function() {return $(this).closest('.Imagebox').outerHeight()/2},
			//      		'opacity': 1

			//   	});
			$('.Imagebox--expandbutton').on('click', function (event) {
				var active = false;
				var $element = $(event.target).closest('.Imagebox--expandbutton').closest('.Imagebox');
				var $expander = $(event.target).closest('.Imagebox').find('.Imagebox--expander');
				var $picture = $element.find('.Imagebox--picture:visible');
				var $text = $element.find('.Imagebox--textwrap');

				$element.toggleClass('Imagebox--active');

				var isVisible = $expander.is(':visible');
				if (isVisible) {
					$expander.addClass('Imagebox--expander-hidden');
				}
				var isNotSmall = $(window).width() >= 800;
				var timeoutMs = isVisible ? 0 : 800;

				if (isNotSmall) {
					_this.scrollTo($element.find('h2'));
				} else {
					timeoutMs = 0;
				}
				var isPictureBigger = $picture.height() > $text.innerHeight();
				// console.log(`${$picture.height()} || ${$text.innerHeight()}`);
				setTimeout(function () {

					$expander.slideToggle("slow", function () {
						active = true;

						if (!isVisible) {
							$expander.removeClass('Imagebox--expander-hidden');
							if (isPictureBigger && isNotSmall) {
								_this.scrollTo($element.find('h2'));
							}
						} else {}
					});
				}, timeoutMs);
			});
		}
	}, {
		key: 'scrollTo',
		value: function scrollTo($element) {
			$('html, body').animate({
				scrollTop: $element.offset().top - 100
			}, 300, 'swing');
		}
	}]);

	return Imagebox;
}();

exports.default = Imagebox;

},{}],4:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _layzr = require('layzr.js');

var _layzr2 = _interopRequireDefault(_layzr);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MediaGrid = function () {
	function MediaGrid() {
		_classCallCheck(this, MediaGrid);

		this.attachLayzr();
	}

	_createClass(MediaGrid, [{
		key: 'attachLayzr',
		value: function attachLayzr() {
			var _this = this;

			var dashGrid = document.body.querySelector('.drag-hero__grid');

			if (dashGrid == null) return;
			this.layzr = (0, _layzr2.default)({
				normal: 'data-normal',
				threshold: 300
			});

			Packery.prototype.initShiftLayout = function (positions, attr) {
				if (positions.length == 0) {
					// if no initial positions, run packery layout
					this.layout();
					return;
				}
				// parse string to JSON
				if (typeof positions == 'string') {
					try {
						positions = JSON.parse(positions);
					} catch (error) {
						this.layout();
						return;
					}
				}

				attr = attr || 'id'; // default to id attribute
				// this._resetLayout();
				// set item order and horizontal position from saved positions
				this.items = positions.map(function (itemPosition) {
					var selector = '[' + attr + '="' + itemPosition.attr + '"]';
					var itemElem = this.element.querySelector(selector);
					var item = this.getItem(itemElem);
					item.rect.x = itemPosition.x * this.packer.width;
					return item;
				}, this);
				this.shiftLayout();
				// this.layout();
				$('.drag-hero__grid').addClass('loaded');
			};

			// this.layzr
			// 	.update() // track initial elements
			// 	.check() // check initial elements
			// 	.handlers(true)
			var vm = this;

			document.addEventListener('DOMContentLoaded', function (event) {
				$('.drag-hero__grid').imagesLoaded().progress(function () {

					var $grid = $('.drag-hero__grid').packery({
						itemSelector: '.drag-hero__item',
						// rowHeight: ".drag-hero__grid__dash-grid-sizer",
						columnWidth: '.drag-hero__grid__dash-grid-sizer',
						// gutter: '',
						initLayout: false, // disable initial layout
						percentPosition: true,
						resize: false

					});
					$grid.packery('initShiftLayout', dragPositions, 'data-item-id');
					vm.$grid = $grid;
					var resized;
					// $(window)
					// 	.on('resize orientationChanged', () => {
					// 		clearTimeout(resized);

					// 		resized = setTimeout(this.resizeCallback, 400);
					// 	});
					$(window).smartresize(function () {
						setTimeout(function () {
							$grid.packery('initShiftLayout', dragPositions, 'data-item-id');
						}, 200);
					}, 200);

					$grid.one('layoutComplete', function () {

						_this.layzr.update().check();
					});
				});
			});
		}
	}, {
		key: 'resizeCallback',
		value: function resizeCallback($grid) {
			this.$grid.packery('initShiftLayout', dragPositions, 'data-item-id');
		}
	}]);

	return MediaGrid;
}();

exports.default = MediaGrid;

},{"layzr.js":1}],5:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Navigation = function () {
	function Navigation() {
		_classCallCheck(this, Navigation);

		this.initSlideout();
		this.maps = false;
		this.mapStack = [];
		this.$wrapper = $('#wrapper');

		this.attachOrientationListener();
	}

	_createClass(Navigation, [{
		key: 'initSlideout',
		value: function initSlideout() {
			var _this = this;

			this.$menu = document.querySelector('#menu');
			this.$contactMenu = document.querySelector('#contactMenu');
			this.menu = new Slideout({
				'panel': document.getElementById('wrapper'),
				'menu': document.getElementById('menu'),
				'padding': 600,
				'tolerance': 70
			});
			this.contactMenu = new Slideout({
				'panel': document.getElementById('wrapper'),
				'menu': document.getElementById('contactMenu'),
				'padding': 600,
				'side': 'right',
				'tolerance': 70
			});

			$('.SiteMenu--item[data-subtarget]').on('click', function (element) {
				var target = $(element.target).attr('data-subtarget');
				$('.SiteMenu--item').removeClass('SiteMenu--item-active');
				$('.SiteNavigation--sub').removeClass('SiteNavigation--sub-open');
				$(element.target).toggleClass('SiteMenu--item-active');

				$('#' + target + '.SiteNavigation--sub').toggleClass('SiteNavigation--sub-open');
			});
			document.querySelector('#SiteHeader--contactToggle').addEventListener('click', function () {
				_this.contactMenu.toggle();
				if (!_this.maps) {
					_this.lazyLoadGoogleMaps();
					_this.maps = true;
				}
				$('html').toggleClass('contact-open');
			});

			document.querySelector('#SiteHeader--navigationToggle').addEventListener('click', function () {
				_this.menu.open();
				$('html').addClass('menu-open');
			});
			document.querySelector('#closeContact').addEventListener('click', function () {
				_this.contactMenu.close();
			});
			document.querySelector('#closeMain').addEventListener('click', function () {
				_this.menu.close();
			});
			this.contactMenu.on('open', function () {
				_this.menu.close();
				$('html').removeClass('menu-open');
			});
			this.menu.on('open', function () {
				_this.contactMenu.close();

				$('html').removeClass('contact-open');
			});
			this.contactMenu.on('close', function () {
				$('html').removeClass('contact-open');
			});
			this.menu.on('close', function () {
				$('html').removeClass('menu-open');
			});
			$('.SocialNav--newsletter input').on('keypress', function (e) {
				if (e.which == 13) {
					_this.processEmail($('.SocialNav--newsletter input').val());
				}
			});
			$('.SocialNav--sendnewsletter').on('click', function (e) {
				_this.processEmail($('.SocialNav--newsletter input').val());
			});
			document.body.addEventListener('mapsInit', function () {
				_this.initMaps();
			});
			$('.ThanksMessage--resend').on('click', function (event) {
				var $form = $(event.currentTarget).closest('.ContactForm');
				$form.find('.ContactForm input, .ContactForm textarea').val();
				$form.find('.ContactForm--tab').eq(1).removeClass('ContactForm--tab-active');
				$form.find('.ContactForm--tab').eq(0).addClass('ContactForm--tab-active');
			});
			$('.ContactForm--send').on('click', function (event) {
				var $form = $(event.currentTarget).closest('.ContactForm');

				if (!_this.validateEmail($form.find('.ContactForm--email').val())) {
					$form.find('#contact-email-error').addClass('InputMessage-show');
				} else {
					_this.sendContactMessage($form);
				}
			});
			$('.OfficeLocation [data-toggle="tab"]').on('shown.bs.tab', function (event) {
				if (_this.mapStack[1].init == 1) {
					return;
				}
				google.maps.event.trigger(_this.mapStack[1].map, 'resize');
				var $el = $('#muenchen_canvas');
				var reCenter = new google.maps.LatLng($el.attr('data-lat'), $el.attr('data-long'));

				_this.mapStack[1].map.setCenter(reCenter);
				_this.mapStack[1].init = 1;
			});
			this.projectsNavigation();
		}
	}, {
		key: 'attachOrientationListener',
		value: function attachOrientationListener() {

			$(window).on('orientationchange', function () {
				$('html').addClass('css-flush');
				window.scrollY;
				// setTimeout(() => {
				// if(this.contactMenu.isOpen()) this.contactMenu.close();
				// if(this.menu.isOpen()) this.menu.close();
				// }, 200);
				$('html').removeClass('css-flush');
			});
		}
	}, {
		key: 'projectsNavigation',
		value: function projectsNavigation() {
			var _this2 = this;

			if (!$('body.projects').length) return;
			var selectedSlide = null;
			$('#projects-sub .ProjectsList a').on('click', function (event) {
				var href = $(event.currentTarget).attr('href');
				_this2.menu.close();
				event.preventDefault();
				_this2.jumpToSlideByHash(href);
			});
		}
	}, {
		key: 'jumpToSlideByHash',
		value: function jumpToSlideByHash(url) {
			// get the project hash from the url
			var selectedHash = url.split('#')[url.split('#').length - 1];

			// get the owl instance
			var owl = $('.Projects').owlCarousel();

			// get the index of the slide-item by project hash
			var selectedIndex = void 0;

			$('.Projects .Projects--item').each(function (index, element) {
				var compareHash = $(element).attr('data-hash');
				if (compareHash == selectedHash) {
					selectedIndex = index;
				}
			});

			// scroll to top and trigger page change
			$("html, body").stop().animate({ scrollTop: 0 }, 500, 'swing', function () {
				// trigger the slide jump
				owl.trigger('to.owl.carousel', [selectedIndex, 1]);
			});
		}
	}, {
		key: 'sendContactMessage',
		value: function sendContactMessage($form) {
			var email = $form.find('.ContactForm--email').val();
			var text = $form.find('.ContactForm--message').val();

			var name = $form.find('.ContactForm--name').val();

			var url = window.location.href;

			$.ajax({
				type: "POST",
				url: "/api/contactMessage",
				// The key needs to match your method's input parameter (case-sensitive).
				data: JSON.stringify({
					email: email,
					message: {
						name: name,
						text: text,
						url: url
					}
				}),
				contentType: "application/json; charset=utf-8",
				dataType: "json",
				success: function success(data) {
					if (data.error !== undefined) {
						$form.find('#contact-email-error').addClass('InputMessage-show');
					} else {
						$form.find('textarea').val('');
						$form.find('input[type=text]').val('');
						$form.find('.ContactForm--tab').eq(0).removeClass('ContactForm--tab-active');
						$form.find('.ContactForm--tab').eq(1).addClass('ContactForm--tab-active');
						// $('#newsletter-success')
						// 	.addClass('InputMessage-show');
					}
				},
				failure: function failure(errMsg) {}
			});
		}
	}, {
		key: 'newsletterSuccess',
		value: function newsletterSuccess(email) {}
	}, {
		key: 'processEmail',
		value: function processEmail(email) {

			if (!this.validateEmail(email)) {
				$('#newsletter-email-error').addClass('InputError-show');
			} else {
				this.sendNewsletter(email);
			}
		}
	}, {
		key: 'validateEmail',
		value: function validateEmail(email) {
			var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
			return re.test(email);
		}
	}, {
		key: 'sendNewsletter',
		value: function sendNewsletter(email) {

			$.ajax({
				type: "POST",
				url: "/api/registerNewsletter",
				// The key needs to match your method's input parameter (case-sensitive).
				data: JSON.stringify({
					email: email
				}),
				contentType: "application/json; charset=utf-8",
				dataType: "json",
				success: function success(data) {
					if (data.error !== undefined) {
						$('#newsletter-failed').addClass('InputMessage-show');
					} else {
						$('#newsletter-success').addClass('InputMessage-show');
					}
				},
				failure: function failure(errMsg) {}
			});
		}
	}, {
		key: 'lazyLoadGoogleMaps',
		value: function lazyLoadGoogleMaps() {
			$.getScript("https://maps.googleapis.com/maps/api/js?key=AIzaSyDAOLtrx95zQRHS9lC45gEimgJ1YiFtQCc&callback=initMaps").done(function (script, textStatus) {}).fail(function (jqxhr, settings, ex) {});
		}
	}, {
		key: 'initMaps',
		value: function initMaps() {
			var vm = this;
			$(".map").each(function () {
				var latitude = $(this).data("lat"),
				    longitude = $(this).data("long"),
				    title = $(this).attr('data-title');
				var mapOptions = {
					zoom: 15,
					center: new google.maps.LatLng(latitude, longitude),
					styles: [{
						featureType: "landscape",
						stylers: [{
							saturation: -100
						}, {
							lightness: 65
						}, {
							visibility: "on"
						}]
					}, {
						featureType: "poi",
						stylers: [{
							saturation: -100
						}, {
							lightness: 51
						}, {
							visibility: "simplified"
						}]
					}, {
						featureType: "road.highway",
						stylers: [{
							saturation: -100
						}, {
							visibility: "simplified"
						}]
					}, {
						featureType: "road.arterial",
						stylers: [{
							saturation: -100
						}, {
							lightness: 30
						}, {
							visibility: "on"
						}]
					}, {
						featureType: "road.local",
						stylers: [{
							saturation: -100
						}, {
							lightness: 40
						}, {
							visibility: "on"
						}]
					}, {
						featureType: "transit",
						stylers: [{
							saturation: -100
						}, {
							visibility: "simplified"
						}]
					}, {
						featureType: "administrative.province",
						stylers: [{
							visibility: "off"
						}]
					}, {
						featureType: "water",
						elementType: "labels",
						stylers: [{
							visibility: "on"
						}, {
							lightness: -25
						}, {
							saturation: -100
						}]
					}, {
						featureType: "water",
						elementType: "geometry",
						stylers: [{
							hue: "#ffff00"
						}, {
							lightness: -25
						}, {
							saturation: -97
						}]
					}]
				};
				var mapElement = document.getElementById($(this).attr("id"));
				var map = new google.maps.Map(mapElement, mapOptions);
				var marker = new google.maps.Marker({
					position: new google.maps.LatLng(latitude, longitude),
					map: map,
					icon: "../../images/pin.png",
					title: title
				});
				var mapObject = {
					map: map,
					init: 0
				};
				vm.mapStack.push(mapObject);
			});
		}
	}]);

	return Navigation;
}();

exports.default = Navigation;

},{}],6:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var News = function () {
	function News() {
		_classCallCheck(this, News);

		this.$el = $('.NewsWidget');
		this.attachListeners();
	}

	_createClass(News, [{
		key: 'attachListeners',
		value: function attachListeners() {
			if (!$('.NewsWidget').length) return;
			$('.NewsWidget--actionbutton').on('click', function () {
				$('.NewsWidget').toggleClass('NewsWidget-closed');
			});
			document.querySelector('.NewsWidget--title').addEventListener('click', function () {
				$('.NewsWidget').toggleClass('NewsWidget-closed');
			});
		}
	}]);

	return News;
}();

exports.default = News;

},{}],7:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ProjectsFilter = function () {
	function ProjectsFilter() {
		_classCallCheck(this, ProjectsFilter);

		this.$el = document.querySelector('#projects-sub #projects-filter');
		this.open = false;
		this.attachListeners();
		this.$activeEl = document.querySelector('#projects-sub #filter-item-text');
	}

	_createClass(ProjectsFilter, [{
		key: 'attachListeners',
		value: function attachListeners() {
			var _this = this;

			$(this.$el).on('click', '.ProjectsFilter--openFilter', function () {
				_this.toggle();
			});
			$('.ProjectsFilter--removeSelection').on('click', function () {
				_this.removeFilters();
			});

			$(this.$el).on('click', '.ProjectsFilter--item', function (event) {
				var $element = $(event.target);
				$('.ProjectsFilter--item').removeClass('ProjectsFilter--item-active');
				var tagId = $element.attr('data-filterproj');

				$element.addClass('ProjectsFilter--item-active');
				$(_this.$el).addClass('ProjectsFilter-active');
				$('#filter-wrap').removeClass();
				$('#filter-wrap').addClass('filter--' + tagId);
				$('#projects-sub .ProjectsList').addClass('ProjectsList-filtered');

				$(_this.$activeEl).text(event.target.childNodes[0].nodeValue);
				_this.close();
			});
		}
	}, {
		key: 'close',
		value: function close() {
			$(this.$el).removeClass('ProjectsFilter-open');
			this.open = false;
		}
	}, {
		key: 'toggle',
		value: function toggle() {
			$(this.$el).toggleClass('ProjectsFilter-open');
			this.open = !this.open;
		}
	}, {
		key: 'removeFilters',
		value: function removeFilters() {
			$('#filter-wrap').removeClass();
			$(this.$el).removeClass('ProjectsFilter-open');
			$(this.$el).removeClass('ProjectsFilter-active');

			this.open = false;
			$('#projects-sub .ProjectsList').removeClass('ProjectsList-filtered');
			$('#projects-sub .ProjectsFilter--item').removeClass('ProjectsFilter--item-active');
			$(this.$activeEl).text('');
		}
	}]);

	return ProjectsFilter;
}();

exports.default = ProjectsFilter;

},{}],8:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Slider = function () {
	function Slider() {
		_classCallCheck(this, Slider);

		this.createProjectSlider();
		this.$el = $('.Projects');
		this.current = 1;
		this.isPositioned = false;
	}

	_createClass(Slider, [{
		key: 'createProjectSlider',
		value: function createProjectSlider() {
			var _this = this;

			$(function () {

				if ($('.Projects').length) {

					// Total amount of projects
					var total = $('.Projects--item').length;

					// Display the total amount
					$('.Projects--pagination .total').text(total);

					// Create the projects fullscreen slider
					_this.owlSlider = $('.Projects').owlCarousel({
						nav: true, // Show next and prev buttons
						items: 1, // Only show one item per page

						// Html elements of the navigation arrows (left and right)
						navText: ['<div data-icon="d" class="icon rotate-left"></div>', '<div data-icon="d" class="icon rotate-right"></div>'],

						lazyLoad: true, // Lazy load images. data-src and data-src-retina for highres.
						URLhashListener: true, // Listen to url hash changes. data-hash on items is required.
						startPosition: 'URLHash', // Url defines which projects is active (linkable pages).

						onInitialize: function onInitialize(event) {
							_this.updatePagination(1);
						},

						onTranslate: function onTranslate(event) {
							_this.updatePagination(event.item.index + 1);
						}
					});
				}

				if ($('.DeviceSlider--carousel').length) {
					var deviceSlider = $('.DeviceSlider--carousel').owlCarousel({
						navigation: true, // Show next and prev buttons
						slideSpeed: 2000,
						lazyLoad: true,
						rewindSpeed: 3000,
						paginationSpeed: 2000,
						autoPlay: false,
						afterInit: function afterInit() {
							$(this.$elem).closest('.DeviceSlider').addClass('loaded');
						},
						stopOnHover: true,
						pagination: true,
						singleItem: true,
						navigationText: ['<div data-icon="d" class="icon rotate-left"></div>', '<div data-icon="d" class="icon rotate-right"></div>']
					});
				}
				if ($('.RelatedProjectsSlider').length) {
					var _$$owlCarousel;

					var relatedSlider = $('.RelatedProjectsSlider--carousel').owlCarousel((_$$owlCarousel = {
						navigation: true, // Show next and prev buttons
						slideSpeed: 300,
						paginationSpeed: 400,
						itemsMobile: [479, 1], //2 items between 600 and 0
						itemsTabletSmall: [769, 1],
						itemsTablet: [1180, 2],
						rewindNav: false,
						itemsDesktopSmall: [1180, 2]
					}, _defineProperty(_$$owlCarousel, 'itemsDesktopSmall', [1920, 3]), _defineProperty(_$$owlCarousel, 'afterInit', function afterInit() {
						var slideCount = $('.RelatedProjectsSlider--carousel .owl-item').length;

						if (slideCount < 3) {
							$('.RelatedProjectsSlider--carousel').addClass('hCenter');
						}
					}), _defineProperty(_$$owlCarousel, 'pagination', false), _defineProperty(_$$owlCarousel, 'items', 3), _defineProperty(_$$owlCarousel, 'navigationText', ['<div data-icon="d" class="dynamic-color icon rotate-left"></div>', '<div data-icon="d" class="dynamic-color icon rotate-right"></div>']), _$$owlCarousel));
				}
				// usage:

				if ($('.ClientSlider').length) {
					setTimeout(function () {
						return _this.setClientWrapperTransform();
					}, 400);
					$(window).smartresize(function () {
						_this.setClientWrapperTransform();
					});

					// console.log('totalWidth', totalWidth); 
					// let relatedSlider = $('.ClientSlider--carousel')
					// 	.owlCarousel({
					// 		navigation: false, // Show next and prev buttons
					// 		slideSpeed: 50,
					// 		itemsTablet: [800, 4], //2 items between 600 and 0
					// 		items: 8,
					// 		itemsMobile: [479, 2],
					// 		itemsDesktopSmall: [1366, 6],
					// 		pagination: false,
					// 		autoPlay: true,
					// 		// navigationText: [`<div data-icon="d" class="dynamic-color icon rotate-left"></div>`, `<div data-icon="d" class="dynamic-color icon rotate-right"></div>`],
					// 	});
					// let slideCount = $('RelatedProjectsSlider--carousel').length; 

					// if(slideCount < 2){
					// 	$('.RelatedProjectsSlider--carousel').addClass('hCenter');

					// }
				}
			});
		}
	}, {
		key: 'setClientWrapperTransform',
		value: function setClientWrapperTransform() {
			$('.ClientSlider--carouselwrapper').css('transform', 'translateX(-' + this.getClientWrapperWidth() + 'px)');

			$('.ClientSlider--carouselwrapper').css('animation', 'carousel 90s linear infinite');
			$('.ClientSlider--carouselwrapper').css('-webkit-animation', 'carousel 90s linear infinite');
			$('.ClientSlider--carouselwrapper').css('animation-direction', 'reverse');
			$('.ClientSlider--carouselwrapper').css('-webkit-animation-direction', 'reverse');
			// animation: carousel 30s linear infinite;
		}
	}, {
		key: 'getClientWrapperWidth',
		value: function getClientWrapperWidth() {
			var totalWidth = 0;
			$('.ClientSlider').find('.Client').each(function () {
				var $el = $(this);
				var width = $el.outerWidth();
				totalWidth += width;
			});
			var lastWidth = $('.ClientSlider').find('.Client:last').outerWidth();

			totalWidth -= $(window).width() - lastWidth / 2;
			return totalWidth;
		}
	}, {
		key: 'updatePagination',
		value: function updatePagination(index) {
			$('.Projects--pagination .current').text(index);
		}
	}, {
		key: 'gotoAnchor',
		value: function gotoAnchor() {
			var _this2 = this;

			this.hash = window.location.hash.substr(1);
			var selectedSlide = null;
			console.log(this.hash);
			if (!this.hash.startsWith('projects-')) return;
			if (this.hash != '') {
				var vm = this;
				setTimeout(function () {
					var projectsOffset = Math.round($('#projects').offset().top);
					var docOffset = $(document).scrollTop();

					if (docOffset == projectsOffset) {
						_this2.isPositioned = true;
						return;
					} else {

						_this2.isPositioned = false;
					}

					$('html, body').animate({
						scrollTop: $('#projects').offset().top
					}, 'slow');
					$('.Projects .Projects--item').each(function (index, element) {
						var compareHash = $(element).attr('data-hash');
						if (compareHash == _this2.hash) {
							selectedSlide = index;
						}
					});
					if (selectedSlide != null) {
						var owlInstance = $(".Projects").data('owlCarousel');
						owlInstance.jumpTo(selectedSlide);
					}
				}, 700);
			}
		}
	}]);

	return Slider;
}();

exports.default = Slider;

},{}],9:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Start = function () {
	function Start() {
		_classCallCheck(this, Start);

		this.sections = [];
		this.activeSection = -1;
		this.sectionHeaderClasses = ['violet', 'violet', 'violet-inverted'];
		this.sectionHeaderName = ['start', 'portfolio', 'projects'];
		this.activate();
		this.snapped = false;
	}

	_createClass(Start, [{
		key: 'activate',
		value: function activate() {
			var _this = this;

			if (!$('.home').length) return;
			$(function () {
				_this.parseHeights();
				_this.scrollHandler();
				_this.sectionHandler();
				_this.scrollSnap();
				// console.log('window_width', $(window)
				// 	.width());
				if ($(window).width() >= 480) {
					var vid = document.getElementById("mood");

					setTimeout(function () {

						$("body").one("touchstart load", function () {

							vid.play();
						}).trigger("load");
					}, 500);
				};

				window.requestAnimationFrame(function () {
					_this.parseHeights();
					_this.scrollHandler();
				});
				$(window).on('scroll', function () {
					_this.parseHeights();
					_this.scrollHandler();
					_this.sectionHandler();
				});
			});
			$(window).resize(function () {
				_this.parseHeights();
				_this.sectionHandler();
			});
		}
	}, {
		key: 'scrollSnap',
		value: function scrollSnap() {
			var $snapElement = $(".Projects ");
			var timeout = 500;
			var timer = void 0;
			$(window).on("scroll", function () {
				clearTimeout(timer);
				timer = setTimeout(function () {

					var scrollTop = $(window).scrollTop();
					var offset = $snapElement.offset().top - 61;
					var scrollDiff = offset - scrollTop;
					if (scrollDiff >= -100 && scrollDiff < -10 || scrollDiff > 10 && scrollDiff <= 100) {
						$('html,body').animate({
							scrollTop: $snapElement.offset().top - 61
						}, 'slow');
						return;
					}
				}, timeout);
			});
		}
	}, {
		key: 'isScrolledIntoView',
		value: function isScrolledIntoView(elem) {
			var docViewTop = $(window).scrollTop();
			var docViewBottom = docViewTop + $(window).height() - 61;

			var elemTop = elem.offset().top;
			var elemBottom = elemTop + elem.height();

			return elemTop <= docViewBottom && elemTop > docViewTop;
		}
	}, {
		key: 'parseHeights',
		value: function parseHeights() {
			var _this2 = this;

			this.sections = [];
			$('.waypoint').each(function (index, element) {
				var $el = $(element);
				var top = $el.position().top - 61;

				_this2.sections.push({
					index: index,
					text: $el.find('.section-title').val(),
					nav: _this2.sectionHeaderClasses[index],
					name: _this2.sectionHeaderName[index],
					top: top,
					height: $el.height()
				});
			});
		}
	}, {
		key: 'scrollHandler',
		value: function scrollHandler() {
			var scrollTop = $(window).scrollTop();
			if (scrollTop >= this.sections[0].height - 200) {
				$('.SiteHeader--lowlay')[0].style.opacity = 1;
				$('.SiteLogo').addClass('SiteLogo-visible');
				return;
			}
			$('.SiteLogo').removeClass('SiteLogo-visible');

			window.requestAnimationFrame(function () {

				var divider = Math.round(scrollTop / 100 * 100);
				divider = divider / 100;

				$('.SiteHeader--lowlay')[0].style.opacity = divider;
				// $('.SiteLogo--picture')[0].style.transform = `scale(${-1+divider})`; 
			});
		}
	}, {
		key: 'sectionHandler',
		value: function sectionHandler() {
			var _this3 = this;

			window.requestAnimationFrame(function () {
				var scrollTop = $(window).scrollTop();
				var inview = _this3.sections.filter(function (section) {
					// console.log(`top: ${section.top} - scrolltop: ${scrollTop} ||| sectiontop+height ${section.top+section.height} - scrollTop: ${scrollTop}`);
					return scrollTop >= section.top && scrollTop < section.top + section.height;
				});
				if (inview[0] !== undefined) {
					_this3.activeSection = inview[0].index;
				}
				if (inview[0] === undefined && _this3.activeSection == inview[0].index) return;
				_this3.activeSection = inview[0].index;

				$('.SiteHeader').removeClass('page-nav-violet page-nav-violet-inverted');
				$('.SiteHeader').addClass('page-nav-' + inview[0].nav);

				$('.SiteLogo--title').text(inview[0].text);
				$('body').attr('data-active-section', inview[0].name);
			});
		}
	}]);

	return Start;
}();

exports.default = Start;

},{}],10:[function(require,module,exports){
'use strict';

var _General = require('./frontend/General');

var _General2 = _interopRequireDefault(_General);

var _Imagebox = require('./frontend/Imagebox');

var _Imagebox2 = _interopRequireDefault(_Imagebox);

var _Slider = require('./frontend/Slider');

var _Slider2 = _interopRequireDefault(_Slider);

var _Navigation = require('./frontend/Navigation');

var _Navigation2 = _interopRequireDefault(_Navigation);

var _ProjectsFilter = require('./frontend/ProjectsFilter');

var _ProjectsFilter2 = _interopRequireDefault(_ProjectsFilter);

var _Start = require('./frontend/Start');

var _Start2 = _interopRequireDefault(_Start);

var _News = require('./frontend/News');

var _News2 = _interopRequireDefault(_News);

var _MediaGrid = require('./frontend/MediaGrid');

var _MediaGrid2 = _interopRequireDefault(_MediaGrid);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function ($) {
  var rtime;
  var timeout = false;
  var delta = 200;
  $(window).resize(function () {
    rtime = new Date();
    if (timeout === false) {
      timeout = true;
      setTimeout(resizeend, delta);
    }
  });

  function resizeend() {
    if (new Date() - rtime < delta) {
      setTimeout(resizeend, delta);
    } else {
      fitImages();
      timeout = false;
    }
  }
  function fitImages() {
    $('.person-image-half').css('height', 'auto');
    $('.person-image-full').css('height', 'auto');
    if ($('body').width() < 768) {
      return;
    }

    var heights = [].map.call($(".person-image-full"), function (cur) {
      return $(cur).height();
    });
    var shortest = Math.min.apply(Math, heights);
    $('.person-image-half').css('height', parseInt((shortest - 30) / 2) + 'px');
    $('.person-image-full').css('height', shortest + 'px');
    console.log("images resized");
  }
  $(window).load(function () {
    $('.grid').masonry({
      itemSelector: '.grid-item',
      columnWidth: '.grid-sizer',
      horizontalOrder: true,
      percentPosition: true
    });

    fitImages();
  });
})(jQuery);

(function ($, sr) {

  // debouncing function from John Hann
  // http://unscriptable.com/index.php/2009/03/20/debouncing-javascript-methods/
  var debounce = function debounce(func, threshold, execAsap) {
    var timeout;

    return function debounced() {
      var obj = this,
          args = arguments;
      function delayed() {
        if (!execAsap) func.apply(obj, args);
        timeout = null;
      };

      if (timeout) clearTimeout(timeout);else if (execAsap) func.apply(obj, args);

      timeout = setTimeout(delayed, threshold || 100);
    };
  };
  // smartresize 
  jQuery.fn[sr] = function (fn) {
    return fn ? this.bind('resize', debounce(fn)) : this.trigger(sr);
  };
})(jQuery, 'smartresize');

var general = new _General2.default();
var imagebox = new _Imagebox2.default();
var slider = new _Slider2.default();
var navigation = new _Navigation2.default();
var projectsFilter = new _ProjectsFilter2.default();
var start = new _Start2.default();
var news = new _News2.default();
var mediaGrid = new _MediaGrid2.default();

},{"./frontend/General":2,"./frontend/Imagebox":3,"./frontend/MediaGrid":4,"./frontend/Navigation":5,"./frontend/News":6,"./frontend/ProjectsFilter":7,"./frontend/Slider":8,"./frontend/Start":9}]},{},[10]);
